// [BD feat] Image Gallery — bd-image-gallery.js
// Drag to scroll (QA 2026-10-08, Figma comment #360): the dev note asks for a horizontal, swipeable row.
// Touch and trackpads already scroll the track natively; a mouse had no way to move it. A mouse drag now
// scrolls the row, snap is held off while dragging (the row settles on a tile on release), and a drag never
// counts as a click on a tile. Keyboard: the track is focusable, arrow keys scroll it natively.
(function () {
  'use strict';

  var SELECTOR = '.bd-image-gallery__track--desktop-horizontal, .bd-image-gallery__track--mobile-horizontal';

  function bind(track) {
    if (track.dataset.bdDragBound) return;
    track.dataset.bdDragBound = '1';

    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    var moved = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (track.scrollWidth <= track.clientWidth) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < 4) return;
      if (!moved) {
        moved = true;
        track.setPointerCapture(e.pointerId);
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startScroll - dx;
    });

    function end(e) {
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      if (track.hasPointerCapture(e.pointerId)) track.releasePointerCapture(e.pointerId);
      // Snap back on with the row where the drag left it: the browser settles it on the nearest tile
      var left = track.scrollLeft;
      track.classList.remove('is-dragging');
      track.scrollLeft = left;
    }

    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    // A drag is not a click
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    // No ghost-image drag of the photos
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  // [BD feat] About QA r4 E2R4-04: a gallery outside the password page (data-bd-gallery-focus) is a tab stop only
  // while its row really scrolls sideways (e.g. Home: stacked on phones = no stop, a row wider than the screen = stop)
  function syncFocus(track) {
    if (track.scrollWidth > track.clientWidth + 1) track.setAttribute('tabindex', '0');
    else if (document.activeElement !== track) track.removeAttribute('tabindex');
  }

  function bindFocus(track) {
    if (track.dataset.bdFocusBound) return;
    track.dataset.bdFocusBound = '1';
    syncFocus(track);
    // re-checked when the row changes size (no ResizeObserver = the server tab stop stays)
    if (window.ResizeObserver) new ResizeObserver(function () { syncFocus(track); }).observe(track);
  }
  // [/BD feat]

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(bind);
    (root || document).querySelectorAll('[data-bd-gallery-focus]').forEach(bindFocus); // [BD feat] E2R4-04 [/BD feat]
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
// [BD feat] Image Gallery
